import { useMemo } from "react";

export const useStyleguideColors = ({ styleguideSetup }) => {
  const styleguideAccentColor = useMemo(() => {
    const lightColor = styleguideSetup?.selectedColors?.light?.[0];

    if (!lightColor) return undefined;

    const darkColor = styleguideSetup?.selectedColors?.dark.find(
      (color) => color.id === lightColor.id
    );

    return {
      accent: {
        light: lightColor.accent,
        dark: darkColor?.accent,
      },
      text: {
        light: lightColor.text,
        dark: darkColor?.text,
      },
    };
  }, [styleguideSetup]);

  return styleguideAccentColor;
};
